module.exports = __webpack_public_path__ + "img/burger.b2fb1625.svg";